<style>
    .container {
        text-align: justify;
    }
</style>

<div class="container">
    <h1>Privacy Policy</h1>
    <p>
        The DevCare Vendor Management System - DVMS (<a href="https://dvms.devcare.com/"
            target="_blank">https://dvms.devcare.com</a>) is committed to safeguarding our users'
        privacy. DVMS provides the vendor organization's HR or procurement team to standardize and streamline every step
        involved in contingent workforce management, starting from procurement, sourcing, interviewing, engaging,
        onboarding and invoicing.
    </p>
    <p><strong>Note: </strong>Any reference to "we," "us," "our website," or DevCare Vendor Management System (DVMS) are
        references to the <a href="https://www.devcare.com/" target="_blank">DevCare Solutions</a> site (the "Website").
    </p>
    <p>
        DevCare Vendor Management System (DVMS) is committed to good privacy practices regarding your personal
        information. Your
        loyalty as a vendor, applicant, customer, or client is essential. We hope that our concerns regarding your
        privacy, as
        described in this policy (the "Privacy Policy" or "Policy"), demonstrate our commitment to making your
        experience with
        DevCare Vendor Management System (DVMS) an enjoyable and satisfying one. If you have questions or complaints
        regarding
        our privacy policy or practices, please contact us at dvmsadmin@devcare.com or info@devcare.com.
    </p>
    <p>
        Although we respect the privacy of all who use our web application/Portal and our online services, we collect
        information from our users, including vendors/applicants/clients/customers. This Privacy Policy governs your
        interaction
        with the Website and your registration for and use of our online services (collectively, the "Services"). Except
        as set
        forth within this Privacy Policy and our Terms of Use Agreement and other published guidelines, we do not
        release
        personally identifiable information about our users (vendors/applicants/clients/customers) without their
        permission.
    </p>
    <h2>A. The information we gather</h2>
    <p>
        In short: We gather all the personal information we request you provide. We collect two types of information
        about users.</p>

    <ol>
        <li>
            <p><strong>Non-personally identifiable information (information that does not identify a specific
                    individual):
                </strong>When vendors
                use the Services, we collect and aggregate information indicating, among other things, which involves
                the
                collection and logging of IP addresses, operating system, and browser software used by each user of the
                Services. Although such information is not personally identifiable, we can determine from the IP address
                of a
                vendor's Internet Service Provider and the geographic location of their point of connectivity. The
                nonperson
                allies' identifiable information we collect helps us identify the authenticity and reliability of the
                vendors.
                We will not disclose this information to any third-party advertisers or promotors. We collect
                non-personally
                identifiable information in part through "cookies." Cookies are small text files placed on your
                computer's hard
                drive that help us determine the type of content, pages you link, the time you spend at any particular
                area of
                the Services, and the Services you choose to use.</p>

            <p>
                Cookies allow us to serve you better and more efficiently and to personalize your experience with the
                Services - for
                example, by enabling us to save your password so that you do not have to reenter it each time you use
                the Services.
                Nevertheless, you should be able to control how and whether your web browser will accept cookies. For
                more information
                on how to do so, please refer to the documentation accompanying your browser. We use pixels, or
                transparent GIF files,
                to help manage online advertising. The information we collect and share is anonymous and not personally
                identifiable. It
                does not contain your name, address, telephone number, or email address.
            </p>
        </li>
        <li>
            <p><strong>Personally identifiable information: </strong>In certain areas of the Services, such as those in
                which you complete a profile,
                submit your resume, or create a new account, we may request that you provide us with certain personally
                identifiable
                information, such as your email address, name, physical addresses, zip code, profession, job titles,
                skill sets, social
                links (hacker rank, git hub, LinkedIn), work experience, certifications, education, passwords, contact
                preferences,
                contact or authentication data, candidate purchase orders, Invoices and timesheet related documents,
                applicant resumes,
                headshot images as may be necessary to support the operation of the Services, such as for billing,
                account maintenance,
                and record-keeping purposes.</p>
            <p>
                The following kinds of <strong>sensitive information</strong> are processed by us, when necessary, with your permission,
                or in another manner allowed by relevant law: contact or authentication data, W9 forms (tax documents),
                SSN(social security numbers), bank account information, certificate of insurance documents, master
                service agreements, I-9/Visa document, driver's license, financial data and, other government
                identifiers. You must be sincere and truthful with all personal information you give us and let us know
                if there are any changes. We will, in such situations, seek to identify which informational items are
                required and which are optional. In the event that you encounter anyone who is improperly collecting or
                using information about you or other users, please contact dvmsadmin@devcare.com or info@devcare.com.
            </p>
        </li>
    </ol>


    <h2>B. How we use (and do not use) the information we gather</h2>
    <p>
        We process your information to provide, improve, and administer our Services, communicate with you for security
        and
        fraud prevention, and comply with the law. We may also process your information for other purposes with your
        consent.
    </p>
    <p>
        We process your personal information for a variety of reasons, depending on how you interact with our Services,
        including:
    </p>
    <ul>
        <li><strong>To facilitate account creation and authentication and otherwise manage user accounts. </strong>We
            may process your
            information so you can create and log in to your account, as well as keep your account in working order.
        </li>

        <li><strong>To enable user-to-user communications. </strong>We may process your information if you use any of
            our offerings to
            communicate with another user.</li>
        <li>
            <strong>To evaluate and improve our Services, products, marketing, and your experience. </strong>We may
            process your information when we
            believe it is necessary to identify usage trends, determine the effectiveness of our promotional campaigns,
            and evaluate
            and improve our Services, products, marketing, and your experience.
        </li>
        <li>
            <strong>To send job requirements, interview, and engagement alerts. </strong>Provide our services and
            products to you, including sending
            you job alerts, calendar alerts, relevant search results recommended jobs and/or candidates (as the case may
            be), and
            other social media communication facilities
        </li>
        <li>
            <strong>For customer support. </strong>Protecting our Users and providing you with customer support
        </li>
        <li>
            <strong>For Legal. </strong>Establishing, exercising, or defending legal rights in connection with legal
            proceedings (including any
            prospective legal proceedings like Master Service Agreement, Purchase Orders and Invoices) and seeking
            professional or
            legal advice in relation to such legal proceedings. To the extent required for identity verification,
            government
            sanctions screening and due diligence checks
        </li>
    </ul>
    <p>
        Please take some time to familiarize yourself with how we use the information we gather. Keep in mind that while
        DVMS
        encourages all third parties involved, including but not limited to its advertisers, to adhere to our policies
        regarding
        the privacy of our visitors and members and to otherwise handle personal information responsibly, we cannot and
        do not
        assume any responsibility for any actions or omissions of third parties, including the manner in which they use
        the
        information received either from DVMS or independently. Nevertheless, in the event you encounter any third party
        associated with, or who claims association with DVMS, who you feel is improperly collecting or using information
        about
        you, please dvmsadmin@devcare.com.We will be happy to forward your message to the third party or contact the
        third party
        on your behalf.
    </p>
    <ol>
        <li>
            <p><strong>How we use (and do not use) non-personally identifiable information: </strong>We use
                non-personally identifiable information
                to build higher quality, more valuable Services. We do this by performing statistical analyses of the
                collective
                characteristics and behavior of our visitors and members and by measuring demographics and interests
                regarding
                specific areas of the Services. We may provide statistical information based on this data to
                advertisers, users, and
                other current and potential business partners. We may also use the aggregate data to inform these third
                parties
                about the number of people who have seen and clicked links to their sites.</p>
        </li>
        <li>
            <p><strong>How we use (and do not use) personally identifiable information: </strong>We do not sell, re-sell or
                distribute for re-sale your
                personally identifiable information. If you believe a DVMS misuses personally identifiable information,
                please notify
                DevCare Vendor Management System (DVMS) at dvmsadmin@devcare.com or info@devcare.com.</p>
        </li>
    </ol>
    <p>
        Please note that DevCare Vendor Management System (DVMS) reserves the right to disclose information submitted by
        or
        concerning any Vendor or user as we reasonably feel necessary to protect our systems or business. We may also
        disclose
        your information as required by law to comply with a subpoena or other legal process when we believe in good
        faith that
        disclosure is necessary to protect our rights, protect your safety and the safety of others, investigate fraud,
        or
        respond to a government request. We cooperate with law enforcement agencies to identify those using our servers
        or
        Services for illegal activities. We also reserve the right to report any suspected unlawful activity to law
        enforcement
        for investigation, prosecution, suspend or terminate your membership in connection with any suspected illegal,
        infringing activity or violation of the Terms of Use Agreement or other published guidelines.
    </p>
    <p>
        If DevCare Vendor Management System (DVMS) is involved in a merger, acquisition, or sale of all or a portion of
        its
        assets. DevCare will notify you via email and/or a prominent notice on our Website of any change in ownership or
        uses of
        your personal information and any choices you may have regarding your personal information. DVMS reserves the
        right to
        assign, sell, license, or otherwise transfer to a third party your personally identifiable information in
        connection
        with an assignment, sale, joint venture, or other transfer or disposition of any portion or all DVMS's or its
        affiliated
        entities' assets or stock.
    </p>
    <p>
        You will be defaulted to "opt in" to receive email notifications related to the posted requisitions, client
        interviews,
        engagements, invoices, and document alerts.
    </p>
    <p>
        We may provide your personal information to companies that provide services to help us with our business
        activities,
        such as screening the applicants, payment transactions and legal. These companies are authorized to use your
        personal
        information only as necessary to provide these services to us.
    </p>
    <p>
        <strong>
            Opting Out:
        </strong>You will receive email notifications related to the posted requisitions, client interviews,
        engagements,
        invoices, and document alerts on behalf of DVMS's affiliates. You may "opt-out" of receiving such materials at
        any time
        in a variety of ways: by using the "UNSUBSCRIBE" link included in each email, by changing your Email
        subscriptions
        preferences on the "My Profile edit" page in your DVMS account or by contacting us at dvmsadmin@devcare.com or
        info@devcare.com If you have provided more than one email address to our service, you may continue to be
        contacted,
        unless you request to unsubscribe each email address you have provided.
    </p>
    <p>
        All information made available to DevCare Vendor Management System (DVMS) may be available to our contractors,
        consultants, and professional advisors (such as attorneys or accountants), but only to the extent necessary for
        them to
        perform services on our behalf and only under a duty of confidentiality.
    </p>
    <h2>C. Security</h2>
    <p>
        The security of your personal information is essential when entering sensitive information (govt. identifier
        information
        and documents such as W9 form, COI, DD Auth, SSN) on our web application. We encrypt the transmission of that
        information using secure socket layer technology (SSL), and we use azure blob storage to encrypt and store
        sensitive
        documents and files. We follow generally accepted standards to protect the personal information submitted during
        transmission and after receiving it. However, no method of transmission over the Internet or electronic storage
        method
        is 100% secure. Therefore, we cannot guarantee its absolute security. If you have any questions about security
        on our
        Website, you can contact us at dvmsadmin@devcare.com or info@devcare.com.
    </p>

    <h2>D. Correcting personal information</h2>
    <p>
        If you want to remove your personally identifiable information from DVMS's database or correct an error in such
        information, please contact us at dvmsadmin@devcare.com or info@devcare.com, and we will use reasonable efforts
        to comply with your request. Keep in mind, however, that there will be residual information that will remain
        within DVMS's databases, access logs, and other records, which may or may not contain such personally
        identifiable information. The residual information will not be used for commercial purposes; if you have
        provided more than one email address to our service, you may continue to be contacted unless you request to
        unsubscribe from each email address you have provided. </p>

    <P>
        <strong>Access:</strong> If your personally identifiable information changes, or if you no longer desire our
        service, you may correct,
        update, amend, delete/remove or deactivate it by making the change on our member information page or by emailing
        our
        Customer Support at dvmsadmin@devcare.com or info@devcare.com or by contacting us by telephone or postal mail at
        the
        contact information listed below:
        <br>
        <strong>Ph: 614-221-2277. Address: 579 Executive Campus Dr, Suite 370, Westerville, OH-43082</strong>

    </P>
    <P>
        <strong>Data Retention:</strong> We will retain your information for as long as your account is active or as
        needed to
        provide you with services. If you wish to cancel your account or request that we no longer use your information
        to
        provide you with services, contact us at dvmsadmin@devcare.com or info@devcare.com. We will retain and use your
        information to comply with our legal obligations, resolve disputes, and enforce our agreements.

    </P>

    <h2>E. Changes to this Privacy Policy</h2>
    <p>
        We may update this privacy statement to reflect changes to our information practices. If we make any material
        changes,
        we will notify you by email (sent to the email address specified in your account) or through a notice on this
        site
        before the change becomes effective. We encourage you to periodically review this page for the latest
        information on our
        privacy practices.
    </p>
    <P>
        By using the Services, you signify your agreement to this Privacy Policy. Please do not use the Services if you
        do not
        agree to this Policy. Your continued use of the Services after changes to this Policy will mean that you accept
        the
        changes; therefore, please bookmark this page and review it periodically. If you have any questions regarding
        this
        Privacy Policy or other privacy issues with the Services, please email us at dvmsadmin@devcare.com or
        info@devcare.com.
    </P>

    <!-- <h2>Changes to this Policy</h2>
    <p>
        [Explain how you may update this privacy policy in the future, and how users will be notified of any changes.]
    </p> -->

    <h2>Questions?</h2>
    <p>
        Questions regarding this Privacy Policy should be directed to dvmsadmin@devcare.com or info@devcare.com.
        All rights reserved. Use of this site is subject to specific Terms and Conditions.
    </p>
</div>